export default __webpack_public_path__ + "static/media/el_farolero.ac5eeb77.png";